import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Inbox, MessageCircle, History, UserCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DashboardHero = ({
  provider,
  contactRequests,
  publishedRequestsCount,
  unreadMessages,
  setActiveTab
}) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-4xl font-bold">Mi Panel</h1>
        <div className="flex items-center gap-2">
          {provider.approved ? (
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">Aprobado</span>
          ) : (
            <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">Pendiente</span>
          )}
          {provider.verified && <Shield className="w-5 h-5 text-[#E6202E]" />}
        </div>
      </div>

      <div className="bg-white rounded-3xl shadow-sm border p-6 md:p-8 mb-5">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <p className="text-sm font-semibold text-[#E6202E] mb-2">Centro de control</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Hola, {provider.business_name || provider.name || 'cuidador'} 👋
            </h2>
            <p className="text-gray-500 mt-2">
              Revisa lo más importante de tu actividad en U-CAN.
            </p>
          </div>

          <Link to="/provider/requests">
            <Button className="bg-[#E6202E] hover:bg-[#D31522] text-white rounded-xl px-8 py-6 text-lg font-semibold">
              Ver solicitudes
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>

        <div className="grid sm:grid-cols-3 gap-3 mt-6">
          <Link to="/provider/requests" className="rounded-2xl bg-red-50 border border-red-100 p-4 hover:border-[#E6202E]/40 transition-colors">
            <p className="text-3xl font-black text-gray-900">{contactRequests.filter(r => r.status === 'pending').length}</p>
            <p className="text-sm font-bold text-gray-800 mt-1">Contactos directos</p>
            <p className="text-xs text-gray-500">Clientes que quieren hablar contigo</p>
          </Link>

          <Link to="/provider/requests?tab=published" className="rounded-2xl bg-gray-50 border border-gray-100 p-4 hover:border-[#E6202E]/40 transition-colors">
            <p className="text-3xl font-black text-gray-900">{publishedRequestsCount}</p>
            <p className="text-sm font-bold text-gray-800 mt-1">Solicitudes abiertas</p>
            <p className="text-xs text-gray-500">Clientes buscando cuidador</p>
          </Link>

          <Link to="/chat" className="rounded-2xl bg-gray-50 border border-gray-100 p-4 hover:border-[#E6202E]/40 transition-colors">
            <p className="text-3xl font-black text-gray-900">{unreadMessages}</p>
            <p className="text-sm font-bold text-gray-800 mt-1">Mensajes nuevos</p>
            <p className="text-xs text-gray-500">Conversaciones por revisar</p>
          </Link>
        </div>
      </div>

      <div className="grid sm:grid-cols-4 gap-3">
        <Link to="/provider/requests" className="bg-white rounded-2xl p-4 shadow-sm border hover:border-[#E6202E]/40 transition-colors flex items-center gap-3">
          <Inbox className="w-5 h-5 text-[#E6202E]" />
          <span className="font-semibold text-sm">Solicitudes</span>
        </Link>
        <Link to="/chat" className="bg-white rounded-2xl p-4 shadow-sm border hover:border-[#E6202E]/40 transition-colors flex items-center gap-3">
          <MessageCircle className="w-5 h-5 text-[#E6202E]" />
          <span className="font-semibold text-sm">Mensajes</span>
        </Link>
        <Link to="/historial" className="bg-white rounded-2xl p-4 shadow-sm border hover:border-[#E6202E]/40 transition-colors flex items-center gap-3">
          <History className="w-5 h-5 text-[#E6202E]" />
          <span className="font-semibold text-sm">Mis servicios</span>
        </Link>
        <Link to="/provider/account" className="bg-white rounded-2xl p-4 shadow-sm border hover:border-[#E6202E]/40 transition-colors flex items-center gap-3">
          <UserCircle className="w-5 h-5 text-[#E6202E]" />
          <span className="font-semibold text-sm">Mi Perfil</span>
        </Link>
      </div>
    </div>
  );
};

export default DashboardHero;
